import React from "react";
import Modal from "react-bootstrap/Modal";

require("./assets/css/Video.css");

const VideoCallDetailModal = ({ show, onHide, call }) => {
    if (!call) return null;

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    const getStatusBadge = (status) => {
        const badges = {
            waiting: { class: 'bg-secondary', text: 'Aguardando' },
            in_queue: { class: 'bg-warning', text: 'Na Fila' },
            in_progress: { class: 'bg-success', text: 'Em Atendimento' },
            completed: { class: 'bg-info', text: 'Finalizado' },
            cancelled: { class: 'bg-danger', text: 'Cancelado' },
            no_show: { class: 'bg-dark', text: 'Não Compareceu' }
        };

        const badge = badges[status] || badges.waiting;

        return (
            <span className={`badge ${badge.class}`}>
                {badge.text}
            </span>
        );
    };

    const calculateDuration = () => {
        const endTime = call.completed_at || call.ended_at;
        if (!call.started_at || !endTime) return '-';

        const start = new Date(call.started_at);
        const end = new Date(endTime);
        const diff = Math.floor((end - start) / 1000);

        const hours = Math.floor(diff / 3600);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;

        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}min`);
        if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

        return parts.join(' ');
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-video-camera me-2"></i>
                    Detalhes do Atendimento
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    {/* Customer Info */}
                    <div className="col-md-6">
                        <div className="video-info-card mb-3">
                            <h6 className="text-muted mb-3">
                                <i className="fa fa-user me-2"></i>
                                Informações do Cliente
                            </h6>
                            <table className="table table-borderless mb-0">
                                <tbody>
                                    <tr>
                                        <td className="text-muted" width="40%">Nome:</td>
                                        <td><strong>{call.client?.name || '-'}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">E-mail:</td>
                                        <td>{call.client?.email || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Telefone:</td>
                                        <td>{call.client?.phone || '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Call Info */}
                    <div className="col-md-6">
                        <div className="video-info-card mb-3">
                            <h6 className="text-muted mb-3">
                                <i className="fa fa-info-circle me-2"></i>
                                Informações da Chamada
                            </h6>
                            <table className="table table-borderless mb-0">
                                <tbody>
                                    <tr>
                                        <td className="text-muted" width="40%">Status:</td>
                                        <td>{getStatusBadge(call.status)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Departamento:</td>
                                        <td>{call.department?.name || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Protocolo:</td>
                                        <td>
                                            <code className="small">{call.protocol || '-'}</code>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Timestamps */}
                    <div className="col-md-12">
                        <div className="video-info-card mb-3">
                            <h6 className="text-muted mb-3">
                                <i className="fa fa-clock me-2"></i>
                                Histórico de Tempo
                            </h6>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="text-center">
                                        <small className="text-muted d-block">Criado em</small>
                                        <span>{formatDate(call.created_at)}</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="text-center">
                                        <small className="text-muted d-block">Iniciado em</small>
                                        <span>{formatDate(call.started_at)}</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="text-center">
                                        <small className="text-muted d-block">Finalizado em</small>
                                        <span>{formatDate(call.completed_at || call.ended_at)}</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="text-center">
                                        <small className="text-muted d-block">Duração</small>
                                        <span className="video-timer">{calculateDuration()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Professional Info */}
                    {(call.professional || call.attendant) && (
                        <div className="col-md-6">
                            <div className="video-info-card mb-3">
                                <h6 className="text-muted mb-3">
                                    <i className="fa fa-headset me-2"></i>
                                    Atendente
                                </h6>
                                <div className="d-flex align-items-center">
                                    <div className="video-user-avatar me-3" style={{ width: '50px', height: '50px', fontSize: '1.2rem' }}>
                                        {(call.professional?.name || call.attendant?.name)?.charAt(0)?.toUpperCase() || 'A'}
                                    </div>
                                    <div>
                                        <strong>{call.professional?.name || call.attendant?.name}</strong>
                                        <br />
                                        <small className="text-muted">{call.professional?.email || call.attendant?.email}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Reason */}
                    {(call.reason || call.description) && (
                        <div className="col-md-12">
                            <div className="video-info-card mb-3">
                                <h6 className="text-muted mb-3">
                                    <i className="fa fa-file-text me-2"></i>
                                    Motivo do Atendimento
                                </h6>
                                <p className="mb-0">{call.reason || call.description}</p>
                            </div>
                        </div>
                    )}

                    {/* Notes */}
                    {call.notes && (
                        <div className="col-md-12">
                            <div className="video-info-card mb-3">
                                <h6 className="text-muted mb-3">
                                    <i className="fa fa-sticky-note me-2"></i>
                                    Observações
                                </h6>
                                <p className="mb-0">{call.notes}</p>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>
                    <i className="fa fa-times me-2"></i>
                    Fechar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default VideoCallDetailModal;
